import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36288061"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "padding": "0px 20px"
  }
}, "活动信息", -1));
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden",
    "padding": "0px 20px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "overflow-y": "auto"
  }
};
const _hoisted_6 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));
const _hoisted_9 = {
  style: {
    "height": "60px",
    "display": "flex",
    "align-items": "end",
    "justify-content": "end",
    "gap": "22px"
  }
};
const _hoisted_10 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1));
const _hoisted_12 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, notification } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";


import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
// 引入组件

export default {
  __name: 'CreateInteraction',
  setup(__props) {
    const components = {
      DownCircleOutlined,
      PlusOutlined
    };
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const itemId = route.params.itemId;
    const activityColumnData = reactive([]);

    // 初始化数据和方法
    const activityStatsForm = ref(null);
    const activityStatsFormData = reactive({
      name: "",
      itemName: "",
      activityStatsTypeId: null,
      activityStatsWeekId: null,
      activityStatsYear: null,
      activityStatsDate: null,
      activityStatsBegin: null,
      activityStatsEnd: null,
      remark: null,
      itemNameOnly: true
    });
    const activityColumnForm = ref(null);
    const activityColumnFormData = reactive({
      title: "",
      name: "",
      type: null,
      required: null,
      length: null,
      scale: null
    });
    var editColumn = null;
    var removeColumns = [];
    var cloneActivityStatsFormData = null;
    var cloneActivityColumnData = null;
    onMounted(async () => {
      let statsTypes = await getActivityStatsTypeRequest();
      statsTypeOptions.value.push(...statsTypes.map(statsType => ({
        value: statsType.activityStatsTypeId,
        label: statsType.activityStatsTypeName
      })));
      let statsWeeks = await getActivityStatsWeekRequest();
      statsWeekOptions.value.push(...statsWeeks.map(statsWeek => ({
        value: statsWeek.activityStatsWeekId,
        label: statsWeek.activityStatsWeekName
      })));
      if (itemId) {
        let columnData = await getActivityColumnRequest(itemId);
        if (Array.isArray(columnData)) {
          activityColumnData.push(...columnData.filter(column => column.name !== "store_name"));
        }
        let activityStatsItem = await getActivityStatsItemRequest(itemId);
        util.propertyClone(activityStatsItem, activityStatsFormData);
        activityStatsFormData.name = activityStatsItem.activityStatsName;
        activityStatsFormData.itemName = activityStatsItem.activityStatsItemName;
        activityStatsFormData.activityStatsBegin = dayjs(activityStatsItem.activityStatsBegin, "YYYY-MM-DD");
        if (activityStatsFormData.activityStatsEnd) {
          activityStatsFormData.activityStatsEnd = dayjs(activityStatsItem.activityStatsEnd, "YYYY-MM-DD");
        }
        // activityStatsFormData.activityStatsDate = [
        //   dayjs(activityStatsItem.activityStatsBegin, "YYYY-MM-DD"),
        //   dayjs(activityStatsItem.activityStatsEnd, "YYYY-MM-DD"),
        // ];

        cloneActivityStatsFormData = JSON.stringify(activityStatsFormData);
        cloneActivityColumnData = JSON.stringify(activityColumnData);
      }
    });
    const activityColumnTable = ref(null);
    const columnTypeOptions = ref([{
      value: "varchar",
      label: "varchar"
    }, {
      value: "text",
      label: "text"
    }, {
      value: "bigint",
      label: "bigint"
    }, {
      value: "int",
      label: "int"
    }, {
      value: "double",
      label: "double"
    }, {
      value: "float",
      label: "float"
    }, {
      value: "decimal",
      label: "decimal"
    }, {
      value: "date",
      label: "date"
    }, {
      value: "datetime",
      label: "datetime"
    }]);
    const requiredOptions = ref([{
      value: true,
      label: "是"
    }, {
      value: false,
      label: "否"
    }]);
    const statsYearOptions = ref([{
      value: "2022",
      label: "2022"
    }, {
      value: "2023",
      label: "2023"
    }, {
      value: "2024",
      label: "2024"
    }, {
      value: "2025",
      label: "2025"
    }, {
      value: "2026",
      label: "2026"
    }, {
      value: "2027",
      label: "2027"
    }, {
      value: "2028",
      label: "2028"
    }]);
    const statsTypeOptions = ref([]);
    const statsWeekOptions = ref([]);
    const activityColumnOpen = ref(false);
    const activityColumnValidRules = ref({
      title: [{
        required: true,
        message: "请输入字段标题",
        tooltip: true
      }],
      name: [{
        required: true,
        message: "请输入字段名称"
      }],
      type: [{
        required: true,
        message: "请选择字段类型"
      }],
      required: [{
        required: true,
        message: "请选择是否必填"
      }],
      length: [{
        validator(rule, value) {
          if (!value && ["varchar", "decimal", "double", "float"].includes(activityColumnFormData.type)) {
            return Promise.reject("请输入长度");
          }
          return Promise.resolve();
        }
      }]
    });
    const validAllEvent = async () => {
      if (itemId != null) {
        const formString = JSON.stringify(activityStatsFormData);
        const columnString = JSON.stringify(activityColumnData);
        console.log(formString, cloneActivityStatsFormData, columnString, cloneActivityColumnData);
        if (formString === cloneActivityStatsFormData && columnString === cloneActivityColumnData) {
          router.push({
            path: "/test-interaction/" + itemId
          });
          return;
        }
      }
      activityStatsForm.value.validate().then(async () => {
        if (activityColumnData == null || activityColumnData.length === 0) {
          notification.error({
            message: "错误",
            description: "没有字段数据"
          });
          return;
        }
        let findIndex = activityColumnData.findIndex(element => element.name == "store_code" && element.type == "varchar" && element.required == true && element.length == 50);
        if (findIndex == -1) {
          notification.error({
            message: "错误",
            description: "必有名称store_code类型varchar长度50必填字段"
          });
          return;
        }
        let activityStatsParam = JSON.parse(JSON.stringify(activityStatsFormData));
        activityStatsParam.activityStatsBegin = dayjs(activityStatsFormData.activityStatsBegin).format("YYYY-MM-DD");
        if (activityStatsFormData.activityStatsEnd) {
          activityStatsParam.activityStatsEnd = dayjs(activityStatsFormData.activityStatsEnd).format("YYYY-MM-DD");
        }
        // activityStatsParam.activityStatsBegin = dayjs(
        //   activityStatsFormData.activityStatsBegin
        // ).format("YYYY-MM-DD");
        // activityStatsParam.activityStatsEnd = dayjs(
        //   activityStatsFormData.activityStatsEnd
        // ).format("YYYY-MM-DD");

        if (itemId == null || itemId == "") {
          activityStatsParam.columns = activityColumnData;
          createActivityStats(activityStatsParam);
        } else {
          activityStatsParam.itemId = itemId;
          activityStatsParam.columns = activityColumnData.filter(object => object.operation != null);
          for (let removeColumn of removeColumns) {
            activityStatsParam.columns.push({
              oldName: removeColumn.name,
              operation: 3
            });
          }
          modifyActivityStats(activityStatsParam);
        }
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onCancel = () => {
      router.go(-1);
    };
    const getActivityStatsItemRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItem(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityColumnRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityColumn(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 创建活动
    const createActivityStats = async activityStatsCreate => {
      proxy.$api.activityStatsRequest.createActivityStats(activityStatsCreate).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "1000") {
            ElNotification({
              title: "Success",
              message: res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            router.push({
              path: "/test-interaction/" + res.result.data.itemId
            });
          } else {
            ElNotification({
              title: "Failure",
              message: res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 修改活动
    const modifyActivityStats = async activityStatsModify => {
      proxy.$api.activityStatsRequest.modifyActivityStats(activityStatsModify).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "1200") {
            ElNotification({
              title: "Success",
              message: res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            router.push({
              path: "/test-interaction/" + activityStatsModify.itemId
            });
          } else {
            ElNotification({
              title: "Failure",
              message: res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const addActivityColumn = () => {
      editColumn = null;
      activityColumnOpen.value = true;
    };
    const editActivityColumn = row => {
      editColumn = JSON.parse(JSON.stringify(row));
      util.propertyClone(row, activityColumnFormData);
      activityColumnOpen.value = true;
    };
    const removeActivityColumn = row => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(ExclamationCircleOutlined),
        okButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        cancelButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        zIndex: 1002,
        content: "要删除字段[" + row.title + "]吗",
        onOk() {
          const $table = activityColumnTable.value;
          if ($table) {
            $table.remove(row);
            let findIndex = activityColumnData.findIndex(element => element.name == row.name);
            if (activityColumnData[findIndex].operation == null) {
              removeColumns.push(row);
            }
          }
          console.log("OK");
        }
      });
    };
    const getActivityStatsTypeRequest = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStatsWeekRequest = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsWeek(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const onActivityColumnCancel = () => {
      activityColumnForm.value.resetFields();
      activityColumnOpen.value = false;
    };
    const onActivityColumnSave = () => {
      activityColumnForm.value.validate().then(async () => {
        let column = JSON.parse(JSON.stringify(activityColumnFormData));
        if (editColumn == null) {
          column.operation = 1;
          activityColumnData.push(column);
        } else {
          let findIndex = activityColumnData.findIndex(element => element.name == editColumn.name);
          util.propertyClone(column, activityColumnData[findIndex]);
          if (activityColumnData[findIndex].operation == null) {
            activityColumnData[findIndex].oldName = editColumn.name;
            activityColumnData[findIndex].operation = 2;
          }
        }
        activityColumnForm.value.resetFields();
        activityColumnOpen.value = false;
      }).catch(error => {
        console.log("error", error);
      });
    };
    return (_ctx, _cache) => {
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_divider), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_form, {
        model: activityStatsFormData,
        ref_key: "activityStatsForm",
        ref: activityStatsForm,
        class: "sts-form",
        labelAlign: "left",
        autocomplete: "off",
        labelCol: {
          flex: '0 0 100px'
        },
        style: {
          "margin-top": "20px",
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, null, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "活动类型：",
              name: "activityStatsTypeId",
              rules: [{
                required: true,
                message: '请选择活动类型'
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                dropdownMatchSelectWidth: false,
                options: statsTypeOptions.value,
                popupClassName: "sts-select-dropdown",
                style: {
                  "max-width": "262px"
                },
                value: activityStatsFormData.activityStatsTypeId,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => activityStatsFormData.activityStatsTypeId = $event)
              }, {
                suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                  class: "ant-select-suffix"
                })]),
                _: 1
              }, 8, ["options", "value"])]),
              _: 1
            }), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: "互动活动名称：",
                  name: "activityStatsWeekId",
                  rules: [{
                    required: true,
                    message: '请选择活动类型'
                  }],
                  labelCol: {
                    flex: '0 0 100px'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    dropdownMatchSelectWidth: false,
                    options: statsWeekOptions.value,
                    popupClassName: "sts-select-dropdown",
                    value: activityStatsFormData.activityStatsWeekId,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => activityStatsFormData.activityStatsWeekId = $event)
                  }, {
                    suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                      class: "ant-select-suffix"
                    })]),
                    _: 1
                  }, 8, ["options", "value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "activityStatsYear",
                  rules: [{
                    required: true,
                    message: '请选择活动类型'
                  }],
                  style: {
                    "margin-left": "21px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    dropdownMatchSelectWidth: false,
                    options: statsYearOptions.value,
                    popupClassName: "sts-select-dropdown",
                    value: activityStatsFormData.activityStatsYear,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => activityStatsFormData.activityStatsYear = $event)
                  }, {
                    suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                      class: "ant-select-suffix"
                    })]),
                    _: 1
                  }, 8, ["options", "value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "name",
                  rules: [{
                    required: true,
                    message: '请输入活动名称'
                  }],
                  style: {
                    "margin-left": "21px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    value: activityStatsFormData.name,
                    "onUpdate:value": _cache[3] || (_cache[3] = $event => activityStatsFormData.name = $event)
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 15
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: "子项目：",
                  name: "itemName",
                  rules: [{
                    required: true,
                    message: '请输入子项目'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    value: activityStatsFormData.itemName,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => activityStatsFormData.itemName = $event)
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "itemNameOnly"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                    style: {
                      "margin-left": "20px"
                    },
                    checked: activityStatsFormData.itemNameOnly,
                    "onUpdate:checked": _cache[5] || (_cache[5] = $event => activityStatsFormData.itemNameOnly = $event)
                  }, {
                    default: _withCtx(() => [_createTextVNode("只显示子项目")]),
                    _: 1
                  }, 8, ["checked"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: "活动时间：",
                  name: "activityStatsBegin",
                  rules: [{
                    required: true,
                    message: '请选择活动时间'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                    popupClassName: "sts-picker",
                    class: "sts-picker",
                    value: activityStatsFormData.activityStatsBegin,
                    "onUpdate:value": _cache[6] || (_cache[6] = $event => activityStatsFormData.activityStatsBegin = $event),
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 15
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "activityStatsEnd"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                    popupClassName: "sts-picker",
                    class: "sts-picker",
                    value: activityStatsFormData.activityStatsEnd,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => activityStatsFormData.activityStatsEnd = $event),
                    style: {
                      "width": "152px",
                      "margin-left": "21px"
                    }
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "活动备注：",
              name: "remark",
              "label-col": {
                span: 3
              },
              "wrapper-col": {
                span: 20
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                "auto-size": {
                  minRows: 10
                },
                value: activityStatsFormData.remark,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => activityStatsFormData.remark = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Button: {
              controlHeight: 24
            },
            Select: {
              fontSizeIcon: 18
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_table, {
          stripe: "",
          height: "auto",
          data: activityColumnData,
          ref_key: "activityColumnTable",
          ref: activityColumnTable,
          class: "sts-table",
          "keep-source": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "title",
            title: "字段标题",
            "edit-render": {
              autofocus: '.ant-input'
            }
          }, null, 8, ["edit-render"]), _createVNode(_component_vxe_column, {
            field: "name",
            title: "字段名称",
            "edit-render": {
              autofocus: '.ant-input'
            }
          }, null, 8, ["edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "type",
            title: "字段类型",
            "edit-render": {
              autofocus: 'ant-select-selection-search-input'
            }
          }), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "required",
            title: "是否必填",
            "edit-render": {
              autofocus: 'ant-select-selection-search-input',
              options: requiredOptions.value
            }
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.required ? "是" : "否"), 1)]),
            _: 1
          }, 8, ["edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "length",
            title: "长度",
            "edit-render": {
              autofocus: '.ant-input-number-input'
            }
          }, null, 8, ["edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "scale",
            title: "小数位数",
            "edit-render": {
              autofocus: '.ant-input-number-input'
            }
          }, null, 8, ["edit-render"]), _createVNode(_component_vxe_column, {
            width: "100",
            field: "action",
            title: ""
          }, {
            header: _withCtx(({}) => [_createVNode(_component_a_button, {
              onClick: addActivityColumn,
              class: "sts-button-circle-icon default",
              shape: "circle"
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "tk_plus",
                iconColor: '#777777',
                iconSize: "16px"
              })]),
              _: 1
            })]),
            default: _withCtx(({
              row
            }) => [_createVNode(_component_a_dropdown, {
              overlayClassName: "sts-dropdown",
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
                default: _withCtx(() => [_createVNode(_component_a_menu_item, {
                  key: "0",
                  onClick: $event => editActivityColumn(row)
                }, {
                  default: _withCtx(() => [_hoisted_7]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_a_menu_item, {
                  key: "1",
                  onClick: $event => removeActivityColumn(row)
                }, {
                  default: _withCtx(() => [_hoisted_8]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "sts-button-circle-icon default",
                shape: "circle",
                disabled: _unref(itemId) != null && _unref(itemId) != '' && row.name === 'store_code'
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  iconName: "more",
                  iconColor: '#777777',
                  iconSize: "16px"
                })]),
                _: 2
              }, 1032, ["disabled"])]),
              _: 2
            }, 1024)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_button, {
        onClick: validAllEvent,
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode("下一步")]),
        _: 1
      }), _createVNode(_component_a_button, {
        onClick: onCancel,
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      })])])])]), _createVNode(_component_a_modal, {
        open: activityColumnOpen.value,
        "onUpdate:open": _cache[15] || (_cache[15] = $event => activityColumnOpen.value = $event),
        closable: false,
        width: "1150px",
        onOk: _ctx.handleOk,
        zIndex: "1001",
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onActivityColumnCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onActivityColumnSave
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: activityColumnFormData,
          ref_key: "activityColumnForm",
          ref: activityColumnForm,
          class: "sts-form",
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          },
          "label-align": "left",
          autocomplete: "off",
          layout: "inline",
          rules: activityColumnValidRules.value
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "字段标题",
            name: "title",
            style: {
              "width": "250px"
            },
            rules: [{
              required: true,
              message: '请输入字段标题'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.title,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => activityColumnFormData.title = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "字段名称",
            name: "name",
            style: {
              "width": "250px"
            },
            rules: [{
              required: true,
              message: '请输入字段名称'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.name,
              "onUpdate:value": _cache[10] || (_cache[10] = $event => activityColumnFormData.name = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "字段类型",
            name: "type",
            style: {
              "width": "120px"
            },
            rules: [{
              required: true,
              message: '请选择字段类型'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              options: columnTypeOptions.value,
              popupClassName: "sts-select-dropdown",
              value: activityColumnFormData.type,
              "onUpdate:value": _cache[11] || (_cache[11] = $event => activityColumnFormData.type = $event)
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix"
              })]),
              _: 1
            }, 8, ["options", "value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "是否必填",
            name: "required",
            style: {
              "width": "120px"
            },
            rules: [{
              required: true,
              message: '请选择字段类型'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              options: requiredOptions.value,
              popupClassName: "sts-select-dropdown",
              value: activityColumnFormData.required,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => activityColumnFormData.required = $event)
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix"
              })]),
              _: 1
            }, 8, ["options", "value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "长度",
            name: "length",
            style: {
              "width": "120px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              value: activityColumnFormData.length,
              "onUpdate:value": _cache[13] || (_cache[13] = $event => activityColumnFormData.length = $event),
              min: 0,
              max: 100000,
              style: {
                "width": "100%"
              }
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "小数位数",
            name: "scale",
            style: {
              "width": "120px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.scale,
              "onUpdate:value": _cache[14] || (_cache[14] = $event => activityColumnFormData.scale = $event)
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "onOk"])], 64);
    };
  }
};